// import * as Sentry from '@sentry/nextjs'
// import { AxiosError } from 'axios'

import { showToast } from '~/utils'

const isProduction = false

export class APIError extends Error {
  constructor(message, status = 500, data = null) {
    super(message)
    this.name = 'APIError'
    this.status = status
    if (data) {
      this.data = data
      /* Sentry.addBreadcrumb({
        category: 'api',
        message: data,
        level: 'info',
      }) */
    }
  }

  toJSON() {
    const result = {
      message: this.message,
      name: this.name,
      status: this.status,
    }
    if (this.data) {
      result.data = this.data
    }
    return result
  }
}

export class EnvError extends Error {
  constructor(variables, status = 501) {
    super('Env vars not set')
    this.name = 'APIError'
    this.status = status
    this.variables = variables
  }

  toJSON() {
    const result = {
      message: this.message,
      status: this.status,
    }
    if (this.variables?.length) {
      result.variables = this.variables
    }
    return result
  }
}

export const handleAPIError = (err /* , captureException = true */) => {
  if (err.code === 'ERR_CANCELED') {
    return
  }
  /* if (captureException) {
    if (err instanceof AxiosError) {
      const {
        response: {
          config: { headers: requestHeaders, url } = {},
          status,
          statusText,
          headers: responseHeaders,
          data,
        } = {},
      } = err
      Sentry.addBreadcrumb({
        category: 'api',
        message: JSON.stringify(
          {
            request: {
              headers: requestHeaders,
              url,
            },
            response: {
              status,
              statusText,
              headers: responseHeaders,
              data,
            },
          },
          null,
          2
        ),
        level: 'info',
      })
    }
    Sentry.captureException(err)
  } */
  const status = err.response?.data.status ?? err.response?.status ?? err.status
  const message =
    err.response?.data?.message ??
    err.response?.message ??
    err.message ??
    err.response?.statusText
  let error
  if (isProduction) {
    error = {
      status: status ?? 500,
      message: message ?? 'API error',
    }
  } else if (err instanceof APIError) {
    error = err.toJSON()
  } else {
    error = { status, message, data: err.response?.data }
  }
  if (error) {
    const message = `${error.name ? `${error.name}: ` : ''}${error.message}`
    showToast(message, { variant: 'error' })
  }
  return error
}
